// Synthesized camera-shutter click via Web Audio API (no audio asset needed).
let ctx = null;

const getCtx = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

// Short band-passed noise burst with an exponential decay envelope.
const tick = (c, time, freq, dur, gainVal) => {
  const size = Math.floor(c.sampleRate * dur);
  const buffer = c.createBuffer(1, size, c.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < size; i++) {
    data[i] = (Math.random() * 2 - 1) * Math.exp(-i / (size * 0.18));
  }
  const src = c.createBufferSource();
  src.buffer = buffer;
  const bp = c.createBiquadFilter();
  bp.type = 'bandpass';
  bp.frequency.value = freq;
  bp.Q.value = 1.2;
  const g = c.createGain();
  g.gain.value = gainVal;
  src.connect(bp);
  bp.connect(g);
  g.connect(c.destination);
  src.start(time);
};

// Two ticks ~70ms apart: mirror-up click + shutter clack.
export const playShutter = () => {
  const c = getCtx();
  if (!c) return;
  const t = c.currentTime;
  tick(c, t, 2600, 0.04, 0.22);
  tick(c, t + 0.07, 1700, 0.06, 0.3);
};
